<template>
  <div class="px-2 bg-white my-course-wrapper">
    <a-tabs default-active-key="1">
      <a-tab-pane
        tab="过期课程"
        key="1"
      >
        <course-content
          type="expire"
          :courseType="'overdue'"
        ></course-content>
      </a-tab-pane>

    </a-tabs>

  </div>
</template>

<script>
import courseContent from '../../myCourse/courseContent.vue'
export default {
  props: {

  },
  data () {
    return {

    }
  },
  components: {
    courseContent
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {

  }
}
</script>

<style scoped lang="less">
.my-course-wrapper {
  height: 100%;
}
</style>
